import { MouseEventHandler, type FC } from "react";
import {
  Flex,
  UseRadioProps,
  useRadio,
  Text,
  useBreakpointValue,
} from "@chakra-ui/react";

const stylePropsByBreakpoint = {
  base: {
    _checked: {
      bg: "th.actionLavenderPrimary",
    },
    _active: {
      bg: "th.actionLavender2",
    },
  },
  md: {
    _checked: {
      bg: "th.actionLavenderPrimary",
      _hover: {
        bg: "th.actionLavender1",
      },
    },
    _hover: {
      bg: "th.actionLavender1",
    },
    _active: {
      bg: "th.actionLavender2",
      _hover: {
        bg: "th.actionLavender2",
      },
    },
  },
};

interface Props extends UseRadioProps {
  onClick?: MouseEventHandler<HTMLInputElement>;
}

export const RadioCard: FC<Props> = ({ onClick, ...props }) => {
  const responsiveStylingProps = useBreakpointValue(stylePropsByBreakpoint);
  const { getInputProps, getRadioProps } = useRadio(props);

  const input = getInputProps();
  const checkbox = getRadioProps();

  return (
    <Flex as="label" w="full">
      <input {...input} />
      <Flex
        {...checkbox}
        align="center"
        bg="th.white"
        border="1px solid"
        borderColor="th.cream2"
        borderRadius="lg"
        cursor="pointer"
        justify="center"
        onClick={onClick}
        px={4}
        py={6}
        w="full"
        {...responsiveStylingProps}
      >
        <Text variant="th-body1">{props.value}</Text>
      </Flex>
    </Flex>
  );
};
